module.exports = __webpack_public_path__ + "img/harvard.a2cbde28.jpg";